// Server-Sent Events: reiner Parser ohne Abhängigkeiten (testbar in Node).

export interface SseEvent {
  event: string
  data: string
}

/**
 * Zerlegt SSE-Rohtext in Ereignisse. Gibt die vollständigen Ereignisse und
 * den unvollständigen Rest zurück (der mit dem nächsten Chunk fortgesetzt wird).
 */
export function parseSseChunk (buffer: string): { events: SseEvent[], rest: string } {
  const normalized = buffer.replace(/\r\n/g, '\n')
  const frames = normalized.split('\n\n')
  const rest = frames.pop() ?? ''
  const events: SseEvent[] = []
  for (const frame of frames) {
    let event = 'message'
    const data: string[] = []
    for (const line of frame.split('\n')) {
      if (line.startsWith('event:')) {
        event = line.slice(6).trim()
      } else if (line.startsWith('data:')) {
        data.push(line.slice(5).replace(/^ /, ''))
      }
    }
    if (data.length > 0) {
      events.push({ event, data: data.join('\n') })
    }
  }
  return { events, rest }
}
